import { MARQUEE_ITEMS } from "@/data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif text-xl sm:text-2xl tracking-tight text-charcoal/70 px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="w-1.5 h-1.5 rotate-45 bg-gold/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    aria-hidden="true"
    data-testid="capability-marquee"
    className="bg-ivory border-y border-line py-6 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);

export default Marquee;
